var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "cl" || _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _vm.userIsBroker
              ? _c("div", { staticStyle: { "padding-top": "20px" } })
              : _vm._e(),
            _vm.selectedView && !_vm.userIsBroker
              ? _c(
                  "b-field",
                  { staticClass: "radio-buttons-container" },
                  [
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-radio-button",
                          {
                            staticClass: "radio-button",
                            class:
                              _vm.selectedView === "Leads" &&
                              "radio-button-selected",
                            attrs: {
                              "data-cy": "button-lead",
                              "native-value": "Leads",
                            },
                            model: {
                              value: _vm.selectedView,
                              callback: function ($$v) {
                                _vm.selectedView = $$v
                              },
                              expression: "selectedView",
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-solid fa-user-group" }),
                            _c("h3", [_vm._v("Leads")]),
                          ]
                        ),
                        _c(
                          "b-radio-button",
                          {
                            staticClass: "radio-button",
                            class:
                              _vm.selectedView === "Brokers" &&
                              "radio-button-selected",
                            attrs: {
                              "data-cy": "button-broker",
                              "native-value": "Brokers",
                            },
                            model: {
                              value: _vm.selectedView,
                              callback: function ($$v) {
                                _vm.selectedView = $$v
                              },
                              expression: "selectedView",
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-solid fa-user-tie" }),
                            _c("h3", [_vm._v("Brokers")]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.selectedView === "Leads"
              ? _c("div", [_c("Leads")], 1)
              : _vm._e(),
            _vm.selectedView === "Brokers"
              ? _c(
                  "div",
                  [
                    _c("Brokers", {
                      attrs: { "user-is-broker": _vm.userIsBroker },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }